/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.CustomBranding {
    angular.module("meevo.plugins.customBranding", []);
}